import { MenuItem, VueRouter } from "@abaco/web-common/src/app";

export function createMenu(router: VueRouter): MenuItem[] {
  return [
    {
      id: "cruscotto_logging_applicativo_module", // <--- underscore
      descrKey: "Cruscotto Logging Applicativo",
      icon: "abc-icon abc-icon-check-list",
      onClick: () => router.push({ name: "cruscotto-logging-home" }), // <--- usa il name della route vera!
      get isVisible() {
        return true;
      },
    },
  ];
}

